import type { Card, ChecklistIndicator } from '@/entities/board';

/** At most this many unfinished checklists get their own indicator; the rest become `…`. */
export const MAX_CHECKLIST_INDICATORS = 3;

/** Unfinished checklists (with items), in the card's content order. Finished ones are not shown. */
export function unfinishedChecklists(card: Card): ChecklistIndicator[] {
  return card.checklists.filter((c) => c.total > 0 && c.completed < c.total);
}
